'use client';

import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export default function IntroPart({ pageData, sDPageExp }: { pageData: any; sDPageExp: any }) {
  const [introRef, inView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  });

  // 曝光埋点
  useEffect(() => {
    if (inView) {
      sDPageExp('导言', 0);
    }
  }, [inView, sDPageExp]);

  // 安全检查：确保pageData存在
  if (!pageData) {
    return null;
  }

  return (
    <Box
      ref={introRef}
      className="w-full px-[24px] py-[40px] lg:px-[60px] lg:py-[50px] 2xl:px-[96px] 2xl:py-[64px]"
    >
      <Box className="mx-auto text-center">
        <h2
          className="font-bb text-[24px] leading-[26px] mb-[4px] lg:text-[36px] lg:leading-[44px] lg:mb-[12px] 2xl:text-[48px] 2xl:leading-[58px] 2xl:mb-[16px] text-primary-text"
          dangerouslySetInnerHTML={{ __html: pageData.title }}
        />
        <h5
          className="font-br text-[12px] leading-[18px] text-primary-text lg:text-[14px] lg:leading-[20px] 2xl:text-[16px] 2xl:leading-[24px]"
          dangerouslySetInnerHTML={{ __html: pageData.description }}
        />
      </Box>
    </Box>
  );
}
